import { render, staticRenderFns } from "./RegisteredProductsWarranty.vue?vue&type=template&id=7dbb415e"
import script from "./RegisteredProductsWarranty.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports